import React from 'react';

const Preloader = () => {
  return (
    <div className="preloader-overlay">
      <div className="preloader-container">
        <div className="preloader-spinner"></div>
        {/* <p className="preloader-text">Processing your request...</p> */}
      </div>
      
      <style jsx>{`
        .preloader-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(255, 255, 255, 0.3); /* Very light background */
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 9999;
          backdrop-filter: blur(2px); /* Slight blur effect */
        }
        
        .preloader-container {
          background-color: rgba(255, 255, 255, 0.8); /* Semi-transparent background */
          padding: 20px 30px;
          border-radius: 8px;
          text-align: center;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          border: 1px solid rgba(0, 0, 0, 0.05);
        }
        
        .preloader-spinner {
          width: 40px;
          height: 40px;
          margin: 0 auto 15px;
          border: 4px solid rgba(151, 15, 47, 0.2); /* Light border color */
          border-top: 4px solid #970f2f; /* Match your app's theme color */
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }
        
        .preloader-text {
          font-size: 14px;
          color: #333;
          margin: 0;
          font-weight: 500;
        }
        
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default Preloader;